import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {EErrorActions, LoadError} from '@app/core/store/actions/error.actions';
import {SnackBar} from '@app/core/services/snackbar.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '@app/core/services/auth.service';
import {EQOLogLevel, QOLogService} from '@quickorder/angular-web-lib';
import {MatDialog} from '@angular/material/dialog';
import {EmailExistsPopupComponent} from '@app/modules/shared/components/email-exists-popup/email-exists-popup.component';
import {Router} from '@angular/router';

@Injectable()
export class ErrorEffects {

	@Effect()
	public onLoadError$ = this.actions$.pipe(
		ofType<LoadError>(EErrorActions.LoadError),
		switchMap((error: LoadError) => {
			const e = error.error;
			if (error.error instanceof HttpErrorResponse) {
				const serverRes = error.error.error as any;
				const status = (e as HttpErrorResponse).status;
				if (status === 401) {
					localStorage.clear();
					this.router.navigate(['/login']);
					this.dialog.closeAll();
				}
				if (status === 422) {
					if (error?.error['error']?.errors.email && error?.error['error']?.errors.email[0] === 'The email has already been taken.' && error.showExistingEmailPopup) {
						this.dialog.open(EmailExistsPopupComponent);
					}
					this.handleErrors(error.error['error'].errors, error.error['error']);

					return [];
				}
				if (serverRes && serverRes.error) {
					this.handleError(serverRes.error, serverRes);
				}
				if (serverRes && serverRes.errors) {
					this.handleErrors(serverRes.errors, serverRes);
				}
			}

			return of({type: 'noop'});
		}),
	);

	constructor(
		private actions$: Actions,
		private snackbar: SnackBar,
		private authService: AuthService,
		private logService: QOLogService,
		private dialog: MatDialog,
		private router: Router,
	) {
	}

	public handleErrors(errorCodes: {}, serverResponse): void {
		let errors = '';
		for (const field in errorCodes as { [key: string]: [] }) {
			errors += errorCodes[field] + '\n';
		}
		this.logService.logContent({
			level: EQOLogLevel.ERROR,
			title: errors,
			actions: [],
		});
	}

	public handleError(errorCode: string, serverResponse): void {
		switch (errorCode) {
			case 'paymentNumbersMissing':
				if (serverResponse.missing_numbers) {
					const missingUsers = serverResponse.missing_numbers.map(i =>
						i.user.first_name + ' ' + i.user.last_name).join(', ');
					this.snackbar.newError(missingUsers, undefined, 'EXPORT.THE_FOLLOWING_PAYMENT_NUMBERS_ARE_MISSING', 30 * 1000);
				}
				if (serverResponse.departments) {
					const missingDepartments = serverResponse.departments.map(i =>
						i.department_name).join(', ');
					this.snackbar.newError(missingDepartments, this.authService.tenant.integration.name, 'SNACK_BAR.MISSING_DEPARTMENT_PAYMENT_NUMBERS', 30 * 1000);
				}
				break;
			case 'userIsNotAvailable':
				this.snackbar.newError('SNACKBAR.EMPLOYEE_IS_NOT_AVAILABLE');
				break;
			case 'pauseGteDuration':
				this.snackbar.newError('SNACKBAR.PAUSE_LONGER_THAN_SHIFT');
				break;
			case 'paymentNumberExists':
				this.snackbar.newError('PAYMENT_NUMBER_IN_USE');
				break;
			case 'invalidPassword':
				this.snackbar.newError('PUNCH_LOGIN.WRONG_PASSWORD_TRY_AGAIN');
				break;
			case 'invalidDatabase':
				this.snackbar.newError('PUNCH_LOGIN.TENANT_ID_NOT_FOUND');
				this.authService.httpService.setTenant(undefined);
				break;
			default:
				this.logService.logContent({
					level: EQOLogLevel.ERROR,
					title: errorCode,
					actions: [],
				});
		}
	}
}
